import { Button, ButtonGroup, useToast } from "@chakra-ui/react"
import { BsPlayFill } from "react-icons/bs"
import { patchUpdateQueueContact } from "../../classes/Queue"
// import { itemData, AL_INFO, useSelectedItemAlertContext, AL_RESET_PASSWORD } from "../../context/selectedItemAlertContext"
import { useFormUpdateContactContext } from '../../context/formUpdateContactContext'
import { useLoadingContext } from "../../context/loadingContext"
import { toastErrDesc, toastVal } from '../../utils/toastUtils';

const TableButtonUpdateContactGroup = ({ row, size = "md" }) => {
    const { updateContactData, setUpdateContact } = useFormUpdateContactContext()
    const { onModalClose, onModalOpen } = useLoadingContext()
    const toast = useToast()

    const actionHandle = async (qid) => {
        onModalOpen()
        const data = {
            tel: updateContactData.form?.tel,
            email: updateContactData.form?.email
        }
        
        await patchUpdateQueueContact(qid, data)
            .then(res => {
                // console.log('update contact')
                // console.log(res)
                onModalClose()
                toast(toastVal({
                    title: "ปรับปรุงข้อมูล สำเร็จ",
                    description: `โทร. ${data.tel} และ อีเมล ${data.email} กรุณาเช็คอีเมลของท่านเพื่อตรวจสอบการส่งการแจ้งเตือนทางอีเมล`
                }))

                setUpdateContact(p=>{
                    return {...p, data: p.data.map(v=>v.id===res.id ? {...v ,email:res.email,tel: res.tel }:v)}
                })
            })
            .catch(err => {
                onModalClose()
                // console.log()
                // console.log(err)
                toast(toastVal({
                    title: "ปรับปรุงข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(err),
                    status: "error",
                }))
            })
    }

    return (
        <ButtonGroup spacing={2} size={size}>
            <Button leftIcon={<BsPlayFill />} onClick={() => actionHandle(row.original.id)} colorScheme="yellow" size="sm">ปรับปรุง</Button>
        </ButtonGroup>
    )
}

export default TableButtonUpdateContactGroup